import Vue from 'vue';
import giftRewardRecords from './gift-reward-record.vue';

export default {
  showGiftRewardRecords(
    gameCode,
    { context = null, backgroundImage, params, fontColor, recordBackgroundColor,
      hidePackageIds, pageSize, option } = {},
  ) {
    return new Promise(() => {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      const GiftRewardRecordsCreator = Vue.extend(giftRewardRecords);
      const giftRewardRecordsInstance = new GiftRewardRecordsCreator({
        el: document.createElement('div'),
        created() {
          this.game_code = gameCode;
          this.params = params;
          this.gameCode = gameCode;
          this.backgroundImage = backgroundImage;
          this.fontColor = fontColor;
          this.hidePackageIds = hidePackageIds;
          this.pageSize = pageSize;
          this.option = option;
          this.recordBackgroundColor  = recordBackgroundColor ;
          this.$on('gift-record-fill-address', () => {
            Vue.prototype.$eventBus.$emit('ceiba:common:events:address-fill');
            this.$destroy();
          });

          this.$on('gift:package:reward:record:event:wx-fill', () => {
            Vue.prototype.$eventBus.$emit('ceiba:common:event:account-wx-qq-fill');
            this.$destroy();
          });

          this.$on('gift:package:close', () => {
            this.$destroy();
          });
          if (context) {
            // context 销毁的时候同时销毁自身
            context.$once('hook:beforeDestroy', () => this.$destroy());
          }
        },
        destroyed() {
          this.$el.remove();
        },
      });

      document.body.appendChild(giftRewardRecordsInstance.$el);
    });
  },
};
